import React from 'react'
import HeaderOne from '../Components/Header/HeaderOne'
import Breadcrumb from '../Components/BreadCrumb/Breadcrumb'
import DestinationDetailsMain from '../Components/Destination/DestinationDetailsMain'
import FooterFour from '../Components/Footer/FooterFour'
import ScrollToTop from '../Components/ScrollToTop'
import SEO from '../Components/SEO/SEO'

function DestinationDetails() {
    return (
        <>
            <SEO 
                title="Destination Details - Tourm Travel Agency"
                description="Discover detailed information about our travel destinations. Learn about amazing places to visit."
                url="/destination"
            />
            <HeaderOne />
            <Breadcrumb
                title="Destination Details"
            />
            <DestinationDetailsMain />
            <FooterFour />
            <ScrollToTop />
        </>
    )
}

export default DestinationDetails
